import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { apolloClient } from '../../../ApolloProvider'
import { localStorageKey } from '../../../utils/localStorageKey'

type Return = () => void

export const useLogout = (): Return => {
  const history = useHistory()

  return useCallback(() => {
    localStorage.removeItem(localStorageKey.token)
    history.push('/login')
    return apolloClient.clearStore()
  }, [history])
}
